export enum snackbarPropTypes {
  ERROR = "error",
  INFO = "info",
  SUCCESS = "success",
  WARNING = "warning",
  CLOSE = "close",
  NO = "",
}
